var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0206 2.90991C8.71058 2.90991 6.02058 5.59991 6.02058 8.90991V11.7999C6.02058 12.4099 5.76058 13.3399 5.45058 13.8599L4.30058 15.7699C3.59058 16.9499 4.08058 18.2599 5.38058 18.6999C9.69058 20.1399 14.3406 20.1399 18.6506 18.6999C19.8606 18.2999 20.3906 16.8699 19.7306 15.7699L18.5806 13.8599C18.2806 13.3399 18.0206 12.4099 18.0206 11.7999V8.90991C18.0206 5.60991 15.3206 2.90991 12.0206 2.90991Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8699 3.26C13.5599 3.17 13.2399 3.1 12.9099 3.06C11.9499 2.94 11.0299 3.01 10.1699 3.26C10.4599 2.52 11.1799 2 12.0199 2C12.8599 2 13.5799 2.52 13.8699 3.26Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0195 20C15.0195 21.65 13.6695 23 12.0195 23C11.1995 23 10.4395 22.66 9.89953 22.12C9.35953 21.58 9.01953 20.82 9.01953 20",
    stroke: "#333333",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.b6664c034b26b1fad878f104a4945024.svg";
export { ForwardRef as ReactComponent };